"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var Box_1 = require("@material-ui/core/Box");
var core_1 = require("@material-ui/core");
var customCheckboxesStyles_1 = require("./customCheckboxesStyles");
var CheckBox_1 = require("@material-ui/icons/CheckBox");
var CheckBoxOutlineBlank_1 = require("@material-ui/icons/CheckBoxOutlineBlank");
var RadioButtonUncheckedOutlined_1 = require("@material-ui/icons/RadioButtonUncheckedOutlined");
var CheckCircle_1 = require("@material-ui/icons/CheckCircle");
var Translation_1 = require("../../../../../common/components/presentation/Translation/Translation");
exports.CustomCheckboxes = function (_a) {
    var formData = _a.formData;
    var _b, _c;
    var styles = customCheckboxesStyles_1.default();
    var value = formData.value, id = formData.id, onChange = formData.onChange, enumOptions = formData.options.enumOptions, rawErrors = formData.rawErrors;
    var checkoutLite = core_1.useTheme().checkoutLite;
    var checkboxIconCircle = (_c = (_b = checkoutLite) === null || _b === void 0 ? void 0 : _b.enquiryForm) === null || _c === void 0 ? void 0 : _c.checkboxIconCircle;
    var selectedValues = new Set(value);
    var handleChange = function (e) {
        selectedValues.has(e.target.name) ? selectedValues.delete(e.target.name) : selectedValues.add(e.target.name);
        onChange(Array.from(selectedValues));
    };
    var checkboxes = enumOptions.map(function (option, index) { return (<Box_1.default className={styles.checkboxContainer} key={index}>
      <core_1.Checkbox icon={checkboxIconCircle ? <RadioButtonUncheckedOutlined_1.default /> : <CheckBoxOutlineBlank_1.default />} checkedIcon={checkboxIconCircle ? <CheckCircle_1.default /> : <CheckBox_1.default />} color={'primary'} id={id} checked={selectedValues.has(option.value)} value={value} size={'small'} onChange={handleChange} data-test={"checkbox:" + option.value} name={option.value} classes={{
        root: styles.root,
    }}/>
      <core_1.Typography variant={'body2'} className={styles.label} data-test={"text:enquiryForm:" + option.value}>
        <Translation_1.default id={option.label}/>
      </core_1.Typography>
      <core_1.Typography className={styles.errorMessage}>{rawErrors && rawErrors[index]} </core_1.Typography>
    </Box_1.default>); });
    return <Box_1.default className={styles.checkboxesContainer}>{checkboxes}</Box_1.default>;
};
exports.default = exports.CustomCheckboxes;
